import { useEffect, useRef } from "react";

export default function GoogleLoginButton({ onSuccess, onError, disabled = false }) {
    const buttonRef = useRef(null);
    const initializedRef = useRef(false);

    useEffect(() => {
        const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

        if (!clientId) {
            onError?.("Falta REACT_APP_GOOGLE_CLIENT_ID en el .env");
            return;
        }

        const interval = setInterval(() => {
            if (
                !initializedRef.current &&
                window.google?.accounts?.id &&
                buttonRef.current
            ) {
                clearInterval(interval);
                initializedRef.current = true;

                window.google.accounts.id.initialize({
                    client_id: clientId,
                    callback: async (response) => {
                        try {
                            if (!response?.credential) {
                                throw new Error("Google no devolvió credencial");
                            }
                            await onSuccess?.(response.credential);
                        } catch (err) {
                            onError?.(err.message || "Error con Google");
                        }
                    },
                });

                buttonRef.current.innerHTML = "";

                window.google.accounts.id.renderButton(buttonRef.current, {
                    theme: "outline",
                    size: "large",
                    text: "signin_with",
                    shape: "rectangular",
                    width: 280,
                });
            }
        }, 300);
        console.log("GOOGLE CLIENT ID FRONT:", process.env.REACT_APP_GOOGLE_CLIENT_ID);
        console.log("ORIGIN FRONT:", window.location.origin);
        return () => clearInterval(interval);
    }, [onSuccess, onError]);

    return (
        <div style={{ opacity: disabled ? 0.6 : 1, pointerEvents: disabled ? "none" : "auto" }}>
            <div ref={buttonRef}></div>
        </div>
    );
}